import TextfieldComponent from "./TextfieldComponent";
import NumberComponent from "./NumberComponent";
import CheckboxComponent from "./CheckboxComponent";
import DatePickerComponent from "./DatePickerComponent";
import RadioButtonsGroup from "./RadioButtonsGroup";
import AccordionComponent from "./AccordionComponent";
import MaskComponent from "./MaskComponent";
import StackButtons from "./stackButtons";
import FormStepper from "./FormStepper";
import DropdownComponent from "./DropdownComponent";
import ButtonComponent from "./ButtonComponent";
import TextComponent from "./TextComponent";
import ScrollingTextWidget from './widget';
import ConsentButtons from './EConsentStackButtons'
import InfoTextComponent from "./InfoTextComponent";
export const Controls = {
  TextfieldComponent,
  NumberComponent,
  CheckboxComponent,
  DatePickerComponent,
  RadioButtonsGroup,
  AccordionComponent,
  MaskComponent,
  StackButtons,
  FormStepper,
  DropdownComponent,
  ButtonComponent,
  TextComponent,
  ScrollingTextWidget,
  ConsentButtons,
  InfoTextComponent
};
